import { render, staticRenderFns } from "./McontactoModals.vue?vue&type=template&id=1217252d"
import script from "./McontactoModals.vue?vue&type=script&lang=js"
export * from "./McontactoModals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports